if (!customElements.get('quick-add-modal')) {
	customElements.define('quick-add-modal', class QuickAddModal extends ModalDialog {
		constructor() {
			super();
			this.modalContent = this.querySelector('[id^="QuickAddInfo-"]');
		}

		hide(preventFocus = false) {
			const cartDrawer = document.querySelector('cart-drawer');
			if (cartDrawer) cartDrawer.setActiveElement(this.openedBy);
			this.modalContent.innerHTML = '';

			if (preventFocus) this.openedBy = null;
			super.hide();
		}

		show(opener) {
			opener.setAttribute('aria-disabled', true);
			opener.classList.add('loading');

			if (opener.querySelector('.loading-overlay__spinner')) {
				opener.querySelector('.loading-overlay__spinner').classList.remove('hidden');
			}

			fetch(opener.getAttribute('data-product-url'))
				.then((response) => response.text())
				.then((responseText) => {
					const responseHTML = new DOMParser().parseFromString(responseText, 'text/html');
					this.productElement = responseHTML.querySelector('section[id^="MainProduct-"]');
					this.preventDuplicatedIDs();
					this.removeDOMElements();
					this.setInnerHTML(this.modalContent, this.productElement.innerHTML, opener);

					if (window.Shopify && Shopify.PaymentButton) {
						Shopify.PaymentButton.init();
					}

					if (window.ProductModel) window.ProductModel.loadShopifyXR();

					this.removeGalleryListSemantic();
					this.updateImageSizes();
					this.preventVariantURLSwitching();

					super.show(opener);
				})
				.finally(() => {
					opener.removeAttribute('aria-disabled');
					opener.classList.remove('loading');

					if (opener.querySelector('.loading-overlay__spinner')) {
						opener.querySelector('.loading-overlay__spinner').classList.add('hidden');
					}

					var slider = new Swiper('.quick-add-modal .js-media-list', {
						slidesPerView: 1,
						autoHeight: true,
						navigation: {
							nextEl: '.swiper-btn--next',
							prevEl: '.swiper-btn--prev',
						},
						pagination: {
							el: `.quick-add-modal .swiper-pagination`,
							clickable: "true",
							type: "bullets",
							renderBullet: function (activeIndex, className) {
								return (
									'<span class="' +
									className +
									'">' +
									"<em>" +
									activeIndex +
									"</em>" +
									"<i></i>" +
									"<b></b>" +
									"</span>"
								);
							},
						},
						on: {
							slideChange: function () {
								window.pauseAllMedia();
							}
						}
					});
				});
		}

		setInnerHTML(element, html, opener) {
			element.innerHTML = html;
            if(element.querySelector('.product-swatches-shades .select-box')){
              element.querySelector('.product-swatches-shades .select-box').addEventListener('click', function() {
                element.querySelector('.product-swatches-shades .options-list').classList.toggle('show');
              });
            }

            if(element.querySelector('.product-swatches-shades-options')){
              var ulElement = element.querySelector('.product-swatches-shades-options ul');
              var eachLI = element.querySelectorAll('.list_product_options');
              
              function updateLastRowClass() {
                var parentTop = ulElement.getBoundingClientRect().top;
                var parentHeight = ulElement.clientHeight;
                var finalParent = parentTop + parentHeight;
                var posArray = [];
              
                // Remove 'tooltip-top' class from all list items before recalculating
                eachLI.forEach(function (li, i) {
                  li.classList.remove("tooltip-top");
                  var lipos = li.getBoundingClientRect().top;
                  if (lipos < finalParent) {
                    posArray.push(lipos);
                  }
                });
              
                // Find the maximum value (the last row) and add the 'tooltip-top' class
                var maxValue = Math.max(...posArray);
                eachLI.forEach(function (li) {
                  if (li.getBoundingClientRect().top === maxValue) {
                    li.classList.add("tooltip-top");
                  }
                });
              }
              // Initial check on page load
              updateLastRowClass();
              
              // Listen to the scroll event on the ul element
              element.querySelector('.product-swatches-shades-options ul').addEventListener('scroll', function () {
                updateLastRowClass();
              });
            }

			// Reinjects the script tags to allow execution. By default, scripts are disabled when using element.innerHTML.
			element.querySelectorAll('script').forEach(oldScriptTag => {
				const newScriptTag = document.createElement('script');
				Array.from(oldScriptTag.attributes).forEach(attribute => {
					newScriptTag.setAttribute(attribute.name, attribute.value)
				});
				newScriptTag.appendChild(document.createTextNode(oldScriptTag.innerHTML));
				oldScriptTag.parentNode.replaceChild(newScriptTag, oldScriptTag);
			});

			// Read more button
			const moreBtn = document.createElement('a');
			moreBtn.textContent = `${theme.quickviewMore}`;
			moreBtn.setAttribute('href', opener.getAttribute('data-product-url'));
			moreBtn.setAttribute('class', 'product__read-more button button--simple');
			moreBtn.innerHTML += `<span class="button-icon">
					<svg
						class="icon icon-button-arrow"
						width="14"
						height="12"
						viewBox="0 0 14 12"
						fill="none"
						xmlns="http://www.w3.org/2000/svg"
					>
						<path d="M7.97218 1L12.8333 6M12.8333 6L7.97218 11M12.8333 6L1.16663 6" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
					</svg>

					</span>`;
			element.querySelector('.product__info-container').appendChild(moreBtn);
          
            if(element.querySelectorAll('.product_description_expanded')) {
              element.querySelectorAll('.product_description_expanded').forEach(function(event) {
                event.addEventListener('click', function() {
                  var truncate = this.previousElementSibling;
                  truncate.classList.toggle('product--description_truncate-hidden');
                  this.textContent = this.textContent === "read more" ? "read less" : "read more";
                });
              });
            }
            element.querySelectorAll('.product_variant_colorway').forEach(function (colorway) {
              colorway.querySelectorAll('input').forEach(function (checkbox) {
                checkbox.addEventListener("change", function () { 
                  colorwaySelected();
                });
              });
            });
            function colorwaySelected() {
              element.querySelectorAll('.product_variant_colorway').forEach(function (colorway) {
                var inputCheckedLength = colorway.querySelectorAll('.product_variant_colorway-group input:checked').length; 
                var checkboxValue = '';
                colorway.querySelectorAll('input').forEach(function (checkbox, index) {
                  var index = index + 1;
                  if(inputCheckedLength != 0) {
                    if(checkbox.checked) {
                      if(inputCheckedLength < 2) {
                        checkboxValue += checkbox.dataset.value;
                      }else{
                        if(inputCheckedLength === index) {
                          checkboxValue += checkbox.dataset.value;    
                        }else{
                          checkboxValue += checkbox.dataset.value + ', ';
                        }
                      }
                    }
                  }else {
                    checkboxValue = "";
                  }
                });
                colorway.querySelector('.product_variant_colorway-name_list').innerText = checkboxValue;
              });
            }
            colorwaySelected();
            
            element.querySelectorAll('.product_pattern').forEach(function (pattern) {
              pattern.querySelectorAll('input').forEach(function (radio) {
                radio.addEventListener("change", function () { 
                  patternSelected();
                });
              });
            });
            function patternSelected() {
              element.querySelectorAll('.product_pattern').forEach(function (pattern) {
                var radioValue = '';
                pattern.querySelectorAll('input').forEach(function (radio) {      
                  if(radio.checked && radio.dataset.value != '') {
                    radioValue += radio.dataset.value;
                  }
                });
                pattern.querySelector('.product_pattern-name_list').innerText = radioValue;
              });
            }
            patternSelected();
            
            if(element.querySelector(".qty_main_product")){
              element.querySelector(".qty_main_product").addEventListener("change",function(input) {
                var inputValue = this.value;
                if(element.querySelectorAll(".product_pattern-group")) {
                  element.querySelectorAll(".product_pattern-group").forEach(function (patternGroup) {
                    patternGroup.querySelectorAll("input[type=radio]").forEach(function (radio) {
                      if(radio.value != '') {
                        radio.dataset.qty = inputValue;
                      }
                    });
                    patternGroup.querySelectorAll(".product_pattern_wrapper").forEach(function (patternWrapper) {
                      if(patternWrapper.querySelector(".product_pattern_product_quantity span")){
                        patternWrapper.querySelector(".product_pattern_product_quantity span").innerText = inputValue;
                      }
                    });
                  });
                }
                if(element.querySelectorAll(".product_variant_colorway-group")) {
                  element.querySelectorAll(".product_variant_colorway-group").forEach(function (colorwayGroup) {
                    colorwayGroup.querySelectorAll(".product_colorway_product_item").forEach(function (colorwayItem) {
                      colorwayItem.dataset.qty = inputValue;
                      if(colorwayItem.querySelector('.product_colorway_product_quantity span')){
                        colorwayItem.querySelector('.product_colorway_product_quantity span').innerText = inputValue;
                      }
                    });
                  });
                }
                if(element.querySelectorAll(".needles-product")) {
                  element.querySelectorAll(".needles-product").forEach(function (needles) {
                    needles.querySelector("input[name=needles]").dataset.pqty = inputValue;
                    needles.querySelector(".needles-product-infoqty span").innerText = inputValue;
                  });
                }
              });
            }
            
            const $money_type = '${{amount}}';
            const $money_format = function(t,r){function e(t,r){return void 0===t?r:t}function a(t,r,a,o){if(r=e(r,2),a=e(a,","),o=e(o,"."),isNaN(t)||null==t)return 0;t=(t/100).toFixed(r);let n=t.split(".");return n[0].replace(/(\d)(?=(\d\d\d)+(?!\d))/g,"$1"+a)+(n[1]?o+n[1]:"")}"string"==typeof t&&(t=t.replace(".",""));let o="",n=/\{\{\s*(\w+)\s*\}\}/,i=r||this.money_format;switch(i.match(n)[1]){case"amount":o=a(t,2);break;case"amount_no_decimals":o=a(t,0);break;case"amount_with_comma_separator":o=a(t,2,".",",");break;case"amount_with_space_separator":o=a(t,2," ",",");break;case"amount_with_period_and_space_separator":o=a(t,2," ",".");break;case"amount_no_decimals_with_comma_separator":o=a(t,0,".",",");break;case"amount_no_decimals_with_space_separator":o=a(t,0,".","");break;case"amount_with_space_separator":o=a(t,2,",","");break;case"amount_with_apostrophe_separator":o=a(t,2,"'",".")}return i.replace(n,o)};
            
            function Totalamount() {
              let SelectVARPrice = 0;
              if(element.querySelector(".variant-selects-sizes .Option-kitopt-select")){
                var kitoptsel = element.querySelector(".variant-selects-sizes .Option-kitopt-select");
                SelectVARPrice = parseFloat(kitoptsel.options[kitoptsel.selectedIndex].dataset.otpprice);
              }
              if(element.querySelectorAll('.needles-product-list input[name=needles]:checked')){
                element.querySelectorAll('.needles-product-list input[name=needles]:checked').forEach( (needle) => {
                  var RECPRODPRICE = parseFloat(needle.getAttribute('data-nprice'));
                  console.log("SelectVARPrice Bettween",RECPRODPRICE);
                  SelectVARPrice += RECPRODPRICE;
                });
              }
              if(element.querySelector('.product_pattern input[name="product[pattern]"]:checked')){
                var selectedPattern = element.querySelector('.product_pattern input[name="product[pattern]"]:checked');
                var patternValue = selectedPattern ? selectedPattern.value : "";
                var patternPRICE = selectedPattern ? selectedPattern.getAttribute('data-patprice') : "";
                if(patternValue){
                  SelectVARPrice += parseFloat(patternPRICE);
                }
              }
              element.querySelector('.product-form__qtyprice').querySelector('.price_total .price__regular').innerText = $money_format(SelectVARPrice, $money_type);
            }
            
            function Totalamountstatic() {
              let SelectVARPricestat = 0;
              if(element.querySelectorAll('.product_variant_colorway-group .colorway-input:checked')){
                element.querySelectorAll('.product_variant_colorway-group .colorway-input:checked').forEach( (colorway) => {
                  var RECPRODPRICE = parseFloat(colorway.getAttribute('data-varprice'));
                  SelectVARPricestat += RECPRODPRICE;
                });
              }
              if(element.querySelector('.product_pattern input[name="product[pattern]"]:checked')){
                var selectedPattern = element.querySelector('.product_pattern input[name="product[pattern]"]:checked');
                var patternValue = selectedPattern ? selectedPattern.value : "";
                var patternPRICE = selectedPattern ? selectedPattern.getAttribute('data-patprice') : "";
                if(patternValue){
                  SelectVARPricestat += parseFloat(patternPRICE);
                }
              }
              element.querySelector('.product-form__qtyprice').querySelector('.price_total .price__regular').innerText = $money_format(SelectVARPricestat, $money_type);
            }
            
            if(element.querySelector(".variant-selects-sizes .Option-kitopt-select")){
              var OPTIONSELECT = element.querySelector(".variant-selects-sizes .Option-kitopt-select");
              OPTIONSELECT.addEventListener("change", (kitopt) => {
                var SelectVAL = kitopt.target.value;
                var SelectVARID = kitopt.target.options[kitopt.target.selectedIndex].dataset.id;
              
                Totalamount();
                element.querySelector('.product-form').querySelector('form').querySelector('input[name=id]').value = SelectVARID;
                var SelectOpt = element.querySelector(".product-swatches-shades");
                SelectOpt.querySelectorAll('.value-options-color').forEach((e) => {
                  e.classList.remove('varirant-active');
                  var DataVal = e.getAttribute('data-value');
                  if(DataVal == SelectVAL){
                    e.classList.add('varirant-active');
                  }
                })
              });
            }
            
            element.querySelectorAll('.needles-product-list input[name=needles]').forEach((checkbox) => {
              checkbox.addEventListener('change', Totalamount);
            });
            element.querySelectorAll('.product_pattern-option input').forEach((checkbox) => {
              checkbox.addEventListener('change', Totalamount);
            });
            element.querySelectorAll('.product_variant_colorway-group .colorway-input').forEach((checkbox) => {
              checkbox.addEventListener('change', Totalamountstatic);
            });
            element.querySelectorAll('.product_pattern-static input').forEach((checkbox) => {
              checkbox.addEventListener('change', Totalamountstatic);
            });
            
            element.querySelectorAll('.list_product_options input').forEach(e => {
              e.onchange = (event) => {
                var SelectedVal = e.value;
                e.closest('.value-options-color-wrapp').querySelector('.product--selected-shad').value = SelectedVal;
              }
            });
            
            /*-----------------*/
            if(element.querySelector('.product-kitoption__submit')){
              element.querySelector('.product-kitoption__submit').addEventListener('click', (submit) => {
                submit.stopPropagation();
                submit.preventDefault();
            
                var form = submit.target.closest('form');
                var MainQuantity = form.querySelector('.qty_main_product').value;
                var PRODID = form.querySelector('input[name=id]').value;
                var selectedShads = element.querySelectorAll('.varirant-active .product--selected-shad');
                var mainProductData = new Array();
                var properties = {};
            
                selectedShads.forEach(function(input, i) {
                  var count = i + 1;
                  var value = input.value;
                  var dataRqty = input.getAttribute('data-rqty');
                  properties[count+". "+value] = dataRqty+" Qty";
                });
                mainProductData.push({
                  id: PRODID,
                  quantity: MainQuantity,
                  properties: properties
                });
                element.querySelectorAll('.needles-product-list input[name=needles]:checked').forEach( (needle) => {
                  var variantId = needle.value;
                  var Quantity = needle.getAttribute('data-pqty');
                  mainProductData.push({
                    id: variantId,
                    quantity: Quantity
                  });
                });
            
                var selectedPattern = element.querySelector('.product_pattern input[name="product[pattern]"]:checked');
                var patternValue = selectedPattern ? selectedPattern.value : "";
                var patternQTY = selectedPattern ? selectedPattern.getAttribute('data-qty') : "";
                if(patternValue){
                  mainProductData.push({
                    id: patternValue,
                    quantity: patternQTY
                  });
                }
                var PatternCart = document.querySelector('cart-notification') || document.querySelector('cart-drawer');
                if(PatternCart){
                  var formData = {
                    'items': mainProductData,
                    'sections': PatternCart.getSectionsToRender().map((section) => section.id),
                    'sections_url': window.location.pathname
                  }
                  PatternCart.setActiveElement(document.activeElement);
                }
               
                fetch('/cart/add.js', {
                  method: 'POST',
                  headers: {
                    'Content-Type': 'application/json'
                  },
                  body: JSON.stringify(formData)
                })
                .then(response => response.json())
                .then(response => {
                  if(response.message != "" && response.message != null) {
                    var productForm = submit.target.closest('product-form');
                    var errorMessageWrapper = productForm.querySelector('.product-form__error-message-wrapper');
                    var errorMessage = errorMessageWrapper.querySelector('.product-form__error-message');
                    errorMessageWrapper.removeAttribute('hidden');  
                    errorMessage.textContent = response.message;
                  } else {
                    var productForm = submit.target.closest('product-form');
                    var errorMessageWrapper = productForm.querySelector('.product-form__error-message-wrapper');
                    errorMessageWrapper.setAttribute('hidden','');  
                    super.hide();
                    PatternCart.renderContents(response);
                  }
                })
                .catch((error) => {
                  console.error('Error:', error);
                })
                .finally(() => {
                  if (PatternCart && PatternCart.classList.contains('is-empty')) PatternCart.classList.remove('is-empty');
                });
              });
            }
            /*-----------------*/
            if(element.querySelector('.product-kitstatic__submit')){
              element.querySelector('.product-kitstatic__submit').addEventListener('click', (submit) => {
                submit.stopPropagation();
                submit.preventDefault();
            
                var formSubmit = true;
                var form = submit.target.closest('form');
                var Quantity = form.querySelector('.qty_main_product').value;
                var properties = {};
                var mainProductData = new Array();
            
                element.querySelectorAll(".product_variant_colorway").forEach(function (inputWrapper) {
                  var length = inputWrapper.querySelectorAll('input[type="checkbox"]:checked').length;
                  var error_message = inputWrapper.querySelector('.product_variant_error');
                  if(length === 0) {
                    formSubmit = false;
                    error_message.innerText = 'Please, select one option.';
                    var scrollInput = inputWrapper.offsetTop;
                    var scrollHeader = element.querySelector('sticky-header').offsetHeight;
                    var scrollDiv = scrollInput - scrollHeader;
                    window.scrollTo({ top: scrollDiv, behavior: 'smooth'});
                  }else{
                    formSubmit = true;
                    error_message.innerText = '';
                  }
                });
              
                element.querySelectorAll('.product_variant_colorway-group .colorway-input:checked').forEach( (colorwayVariants) => {
                  var variantTitle = colorwayVariants.dataset.titleValue;
                  var variantId = colorwayVariants.value;
                  var ColorProdList = colorwayVariants.nextElementSibling.querySelector('.product_variant_colorway_product_list');
                  var properties = {};
                  ColorProdList.querySelectorAll('.product_colorway_product_item').forEach((coldata, i) => {
                    var count = i + 1;
                    var DataProductId = coldata.getAttribute('data-product-id');
                    var DataProduct = coldata.getAttribute('data-product');
                    var DataQty = coldata.getAttribute('data-qty');
                    var finalQty = DataQty * Quantity;
                    properties["Colorway"] = variantTitle;
                    mainProductData.push({
                      id: DataProductId,
                      quantity: finalQty,
                      properties: properties
                    });
                  });
                });
               
                var selectedPattern = element.querySelector('.product_pattern input[name="product[pattern]"]:checked');
                var patternValue = selectedPattern ? selectedPattern.value : "";
                var patternQTY = selectedPattern ? selectedPattern.getAttribute('data-qty') : "";
                if(patternValue){
                  mainProductData.push({
                    id: patternValue,
                    quantity: patternQTY
                  });
                }
              
                if(formSubmit) {
                  var PatternCart = document.querySelector('cart-notification') || document.querySelector('cart-drawer');
                  if(PatternCart){
                    var formData = {
                      'items': mainProductData,
                      'sections': PatternCart.getSectionsToRender().map((section) => section.id),
                      'sections_url': window.location.pathname
                    }
                    PatternCart.setActiveElement(document.activeElement);
                  }
                
                  fetch('/cart/add.js', {
                    method: 'POST',
                    headers: {
                      'Content-Type': 'application/json'
                    },
                    body: JSON.stringify(formData)
                  })
                  .then(response => response.json())
                  .then(response => {
                    if(response.message != "" && response.message != null) {
                      var productForm = submit.target.closest('product-form');
                      var errorMessageWrapper = productForm.querySelector('.product-form__error-message-wrapper');
                      var errorMessage = errorMessageWrapper.querySelector('.product-form__error-message');
                      errorMessageWrapper.removeAttribute('hidden');  
                      errorMessage.textContent = response.message;
                    } else {
                      var productForm = submit.target.closest('product-form');
                      var errorMessageWrapper = productForm.querySelector('.product-form__error-message-wrapper');
                      errorMessageWrapper.setAttribute('hidden','');  
                      super.hide();
                      PatternCart.renderContents(response);
                    }
                  })
                  .catch((error) => {
                    console.error('Error:', error);
                  })
                  .finally(() => {
                    if (PatternCart && PatternCart.classList.contains('is-empty')) PatternCart.classList.remove('is-empty');
                  });
                }
              });
            }
            const $fbt_money_format = function(t,r){function e(t,r){return void 0===t?r:t}function a(t,r,a,o){if(r=e(r,2),a=e(a,","),o=e(o,"."),isNaN(t)||null==t)return 0;t=(t/100).toFixed(r);let n=t.split(".");return n[0].replace(/(\d)(?=(\d\d\d)+(?!\d))/g,"$1"+a)+(n[1]?o+n[1]:"")}"string"==typeof t&&(t=t.replace(".",""));let o="",n=/\{\{\s*(\w+)\s*\}\}/,i=r||this.money_format;switch(i.match(n)[1]){case"amount":o=a(t,2);break;case"amount_no_decimals":o=a(t,0);break;case"amount_with_comma_separator":o=a(t,2,".",",");break;case"amount_with_space_separator":o=a(t,2," ",",");break;case"amount_with_period_and_space_separator":o=a(t,2," ",".");break;case"amount_no_decimals_with_comma_separator":o=a(t,0,".",",");break;case"amount_no_decimals_with_space_separator":o=a(t,0,".","");break;case"amount_with_space_separator":o=a(t,2,",","");break;case"amount_with_apostrophe_separator":o=a(t,2,"'",".")}return i.replace(n,o)};
            if (element.querySelector('.prod_total_price')){
              const $fbt_currency = element.querySelector('.prod_total_price').getAttribute('data-currency');
              element.querySelector(".qty_main_product").addEventListener("change",function(e) {
                 var ProductPrice = element.querySelector(".prod_total_price").dataset.totalprice;
                 var ProductComparePrice = element.querySelector(".prod_total_price").dataset.comparePrice;
                 var ProductQty =  this.value;
                 var ProductFinalPrice =  ProductPrice * ProductQty;
                 var ProductFinalComparePrice =  ProductComparePrice * ProductQty;
                 console.log("Product Qty",this.value,"Product Price",ProductPrice,"Product Final Price",ProductFinalPrice,"Product Compare Price",ProductComparePrice,"ProductFinalComparePrice",ProductFinalComparePrice);
                if(ProductFinalComparePrice && ProductFinalComparePrice) {
                  element.querySelector(".prod_total_price").querySelector(".price__sale").querySelector(".price-item--sale").innerHTML = $fbt_money_format(ProductFinalPrice, $fbt_currency);
                  element.querySelector(".prod_total_price").querySelector(".price__sale").querySelector(".price-item--regular").innerHTML = $fbt_money_format(ProductFinalComparePrice, $fbt_currency);
                } else {
                  element.querySelector(".prod_total_price").querySelector(".price-item--regular").innerHTML = $fbt_money_format(ProductFinalPrice, $fbt_currency);
                }
              });
            }
		}

		removeDOMElements() {
			const pickupAvailability = this.productElement.querySelector('pickup-availability');
			if (pickupAvailability) pickupAvailability.remove();

			const productModal = this.productElement.querySelector('product-modal');
			if (productModal) productModal.remove();

			const gift = this.productElement.querySelector('.customer');
			if (gift) gift.remove();
		}

		preventDuplicatedIDs() {
			const sectionId = this.productElement.dataset.section;
			this.productElement.innerHTML = this.productElement.innerHTML.replaceAll(sectionId, `quickadd-${ sectionId }`);
			this.productElement.querySelectorAll('variant-selects, variant-radios').forEach((variantSelect) => {
				variantSelect.dataset.originalSection = sectionId;
			});
		}

		preventVariantURLSwitching() {
			if (this.modalContent.querySelector('variant-radios,variant-selects')) {
				this.modalContent.querySelector('variant-radios,variant-selects').setAttribute('data-update-url', 'false');
			}
		}

		removeGalleryListSemantic() {
			const galleryList = this.modalContent.querySelector('[id^="Slider-Gallery"]');
			if (!galleryList) return;

			galleryList.setAttribute('role', 'presentation');
			galleryList.querySelectorAll('[id^="Slide-"]').forEach(li => li.setAttribute('role', 'presentation'));
		}

		updateImageSizes() {
			const product = this.modalContent.querySelector('.product');
			const desktopColumns = product.classList.contains('product--columns');
			if (!desktopColumns) return;

			const mediaImages = product.querySelectorAll('.product__media img');
			if (!mediaImages.length) return;

			let mediaImageSizes = '(min-width: 1000px) 715px, (min-width: 750px) calc((100vw - 11.5rem) / 2), calc(100vw - 4rem)';

			if (product.classList.contains('product--medium')) {
				mediaImageSizes = mediaImageSizes.replace('715px', '605px');
			} else if (product.classList.contains('product--small')) {
				mediaImageSizes = mediaImageSizes.replace('715px', '495px');
			}

			mediaImages.forEach(img => img.setAttribute('sizes', mediaImageSizes));
		}
	});
}
